var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.data.chapters),function(chapter){return _c('chapter-box',{key:chapter.id,staticClass:"col-12 col-sm-6 col-md-4",attrs:{"data":chapter},on:{"select":_vm.goToChapter}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }